import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";

import {
  deleteTreatmentBundleById,
  getTreatmentBundles,
} from "../../../redux/reducers/planSlice";
import { AppColors } from "../../../util/AppColors";
import TreatmentCreate from "./TreatmentCreate";

const tableHeader = [
  "bundleName",
  "species",
  "createdBy",
  "lastUpdated",
  "extraStatus",
];

const TreatmentBundle = () => {
  const dispatch = useDispatch();
  const [createVsble, setCreateVsble] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [delModVsble, setDelModVsble] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const { treatmentBundles } = useSelector((state) => state?.plan);

  useEffect(() => {
    dispatch(getTreatmentBundles());
  }, []);

  const handleDelete = (det) => {
    setSelectedPlan(det);
    setDelModVsble(true);
  };

  const handleEdit = (det) => {
    setSelectedPlan(det);
    setCreateVsble(true);
  };

  const getTableList = () => {
    return treatmentBundles?.map((pln) => ({
      ...pln,
      bundleName: pln?.bundleName,
      species: pln?.species?.join(", "),
      createdBy: pln?.clinicId,
      lastUpdated: moment().format("DD MMM YYYY"),
      extraStatus: (
        <div className="flex-row">
          <img
            src={require("../../../assets/images/png/delete.png")}
            alt=""
            className="imghw30 cursor"
            onClick={() => handleDelete(pln)}
          />

          <img
            src={require("../../../assets/images/png/editWitTxt.png")}
            alt=""
            className="ml10 imghw30 cursor"
            onClick={() => handleEdit(pln)}
          />
        </div>
      ),
    }));
  };

  const handleCloseDel = () => {
    setSelectedPlan(null);
    setDelModVsble(false);
  };

  const handleConfirmDel = () => {
    dispatch(deleteTreatmentBundleById(selectedPlan?.treatmentId)).then(
      (res) => {
        if (res?.payload) {
          dispatch(getTreatmentBundles());
          handleCloseDel();
        }
      }
    );
  };

  return (
    <>
      {createVsble && (
        <TreatmentCreate
          setCreateVsble={setCreateVsble}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
        />
      )}
      {!createVsble && (
        <div>
          <div className="flex-row-ali-cen flex-center mt5">
            <div className="w30Per">
              <CustomTextField
                placeholder="Search"
                name="name"
                fullWidth
                handleChange={(e) => setSearchValue(e?.target?.value)}
                value={searchValue}
                backgroundColor={AppColors.lightPink}
              />
            </div>
            <div className="w7Per ml20">
              <CustomButton
                text="Create"
                onClick={() => setCreateVsble(true)}
              />
            </div>
          </div>

          <CustomTable columns={tableHeader} datas={getTableList()} grey />
        </div>
      )}

      <CustomModal
        open={delModVsble}
        onClose={handleCloseDel}
        header="Delete"
        modal
        modalWidth={30}
      >
        <div className="ml10">Are you sure want to delete the plan?</div>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleCloseDel} smallBtn />
          </div>
          <div className="ml20">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleConfirmDel}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default TreatmentBundle;
